export default "__VITE_ASSET__f9c3ffa4__"